/**
 * Sprint 49 (PoC Web) — URL del logo del negocio según el entorno.
 *
 * En Electron el logo se sirve por el protocolo privilegiado `branding://`
 * (registrado en main/index.ts). Ese scheme NO existe en el navegador, así que
 * en el build web (`vite build --mode web`) el servidor Fastify expone el mismo
 * archivo, mismo origen, en `/branding/logo.png`. Usar mismo-origen evita además
 * violaciones de CSP (`img-src 'self'`).
 *
 * `version` es un CACHE-BUSTER: debe cambiar cuando el logo se reemplaza, o el
 * navegador y Cloudflare (que cachea `/branding/*` en el edge) siguen sirviendo
 * la copia vieja. Se pasa `negocio.fechaModificacion` (cambia al guardar el
 * logo); NUNCA `negocio.id` (constante → la URL no cambia → logo viejo pegado).
 */
const ES_WEB = import.meta.env.MODE === 'web';

/** Deriva un token estable-por-versión: epoch ms para fechas, el valor si no. */
function tokenDeVersion(version: string | number | Date): string | number {
  if (version instanceof Date) return version.getTime();
  if (typeof version === 'string') {
    const t = Date.parse(version);
    return Number.isNaN(t) ? encodeURIComponent(version) : t;
  }
  return version;
}

export function logoUrl(version: string | number | Date = 1): string {
  const v = tokenDeVersion(version);
  return ES_WEB ? `/branding/logo.png?v=${v}` : `branding://logo.png?v=${v}`;
}

/**
 * Sprint 107 — La URL del logo que sale por la impresora térmica.
 *
 * Mismo cache-buster por versión que el otro: sin él, el edge de Cloudflare pisa el `no-cache` del
 * origen y el negocio sigue viendo el logo viejo después de cambiarlo (lección del Sprint 56).
 */
export function logoTicketUrl(version: string | number | Date = 1): string {
  const v = tokenDeVersion(version);
  return ES_WEB ? `/branding/logo-ticket.png?v=${v}` : `branding://logo-ticket.png?v=${v}`;
}
